import http from "../../helpers/http";
import * as helpers from "../../helpers/helpers";

import {
  FETCH_SUBSCRIPTION_OFFERS_CONTENT,
  FETCH_SUBSCRIPTION_OFFERS_CONTENT_SUCCESS,
  FETCH_SUBSCRIPTION_OFFERS_CONTENT_FAILED
} from "./actionTypes";

export const fetchSubscriptionOffers = () => (dispatch) => {
  dispatch({
    type: FETCH_SUBSCRIPTION_OFFERS_CONTENT,
    payload: null
  });
  http
    .post(
      "user/dashboard-subscription-offers",
      helpers.doObjToFormData({ token: localStorage.getItem("authToken") })
    )
    .then(({ data }) => {
      dispatch({
        type: FETCH_SUBSCRIPTION_OFFERS_CONTENT_SUCCESS,
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_SUBSCRIPTION_OFFERS_CONTENT_FAILED,
        payload: error
      });
    });
};
